import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import GeneralPaymentCycleRegistrationForm from "../ones/GeneralPaymentCycleRegistrationForm";
import DebtRegistrationForm from "../ones/DebtRegistrationForm";
import OneStudent from '../ones/OneStudent';

export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	
	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function getData() {
		await callApi("get-debt-data", { uuid }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && data) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							{data.title}
							<br/>
							<span className="badge bg-secondary">Student Debt</span>
						</h6>
						<hr/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<OneStudent data={data.studentData}/>
							</div>
						</div>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Debt Title</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.title}
						</h6>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">Debt Amount</label>
						<h6
							style={{
								fontSize: "24px"
							}}
						>
							{formatMoney(data.amount)} TZS
						</h6>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">Debt Due Date</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.dateDue}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Debt Description</label>
						<pre
							style={{
								fontSize: "18px",
							}}
						>
							{data.description || 'N/A'}
						</pre>

						<hr/>
					</div>

					

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Edit This Debt</h6>
								<hr/>
								<DebtRegistrationForm callback={getData} data={data} />
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}